import React from "react";
import { connect } from "react-redux";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { toast } from "react-toastify";
import { getArticlesApi, saveWebTocApi } from "../../api/articles";
import WebTocListItem from "../WebTocListItem/WebTocListItem";
import { generateUniqueID } from "../../utils/utils";
import "./WebEditTocContainer.css";

class WebEditTocContainer extends React.Component {
  constructor(props) {
    super(props);

    this.saveClicked = this.saveClicked.bind(this);
    this.createClicked = this.createClicked.bind(this);
    this.deleteWebTocArticle = this.deleteWebTocArticle.bind(this);
    this.modifyOneWebTocData = this.modifyOneWebTocData.bind(this);

    this.state = {
      isSaveLoading: false,
      articleIDs: null,
      articlesDict: {}
    };
  }

  componentDidMount() {
    this.loadArticles();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.issue !== this.props.issue) {
      this.loadArticles();
    }
  }

  async loadArticles() {
    const { issue } = this.props;

    if (issue == null) {
      return;
    }

    this.setState({ articleIDs: null, articlesDict: {} });

    try {
      const articles = await getArticlesApi(issue.id, false);
      const newArticleIDs = articles.map(article => article.id);

      let newDict = {};
      let i = 0;
      for (i = 0; i < articles.length; i++) {
        newDict[articles[i].id] = {
          id: articles[i].id,
          title: articles[i].title
        };
      }

      this.setState({
        articleIDs: newArticleIDs,
        articlesDict: newDict
      });
    } catch (e) {
      toast.error(e.toString());
    }
  }

  async saveClicked() {
    this.setState({
      isSaveLoading: true
    });

    try {
      const { issue } = this.props;
      const { articleIDs, articlesDict } = this.state;

      const tocs = articleIDs.map(articleID => {
        let toc = {
          title: articlesDict[articleID].title
        };

        if (!articleID.startsWith("client-")) {
          toc["article_id"] = articleID;
        }

        return toc;
      });

      await saveWebTocApi(issue.id, tocs);
      this.loadArticles();
    } catch (e) {
      toast.error(e.toString());
    }

    this.setState({
      isSaveLoading: false
    });
  }

  createClicked(index) {
    const { isSaveLoading, articlesDict, articleIDs } = this.state;

    if (isSaveLoading) {
      return;
    }

    const idx = isNaN(index) ? 0 : index;

    let newDict = { ...articlesDict };
    let newArr = [...articleIDs];

    const newID = generateUniqueID();

    newArr.splice(idx, 0, newID);

    newDict[newID] = {
      id: newID,
      title: ""
    };

    this.setState({
      articleIDs: newArr,
      articlesDict: newDict
    });
  }

  deleteWebTocArticle(id) {
    const { isSaveLoading, articleIDs, articlesDict } = this.state;

    if (isSaveLoading) {
      return;
    }

    const newArticleIDs = articleIDs.filter(articleID => articleID !== id);
    const newDict = { ...articlesDict };

    delete newDict[id];

    this.setState({
      articleIDs: newArticleIDs,
      articlesDict: newDict
    });
  }

  modifyOneWebTocData(id, title) {
    const { isSaveLoading, articlesDict } = this.state;

    if (isSaveLoading) {
      return;
    }

    const newDict = { ...articlesDict };
    const article = newDict[id];

    if (article != null) {
      article.title = title;
      this.setState({
        articlesDict: newDict
      });
    }
  }

  renderSwitch() {
    const { isSaveLoading, articleIDs, articlesDict } = this.state;

    if (articleIDs == null) {
      return (
        <div className="web_edit_spinner_container">
          <Spinner animation="grow" />
        </div>
      );
    } else {
      return articleIDs.map((articleID, idx) => (
        <Row key={articleID}>
          <Col>
            <WebTocListItem
              idx={idx + 1}
              articleID={articleID}
              article={articlesDict[articleID]}
              isSaveLoading={isSaveLoading}
              createClicked={this.createClicked}
              deleteWebTocArticle={this.deleteWebTocArticle}
              modifyOneWebTocData={this.modifyOneWebTocData}
            />
          </Col>
        </Row>
      ));
    }
  }

  render() {
    const { isSaveLoading } = this.state;

    return (
      <React.Fragment>
        <Row className="toc_utility_section">
          <Col>
            <Button
              disabled={isSaveLoading}
              variant="success"
              size="sm"
              className="web_toc_save_btn"
              onClick={this.saveClicked}
            >
              {isSaveLoading ? (
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              ) : (
                <span className="fa fa-save" />
              )}
            </Button>
            <Button
              disabled={isSaveLoading}
              variant="warning"
              size="sm"
              className="web_toc_plus_btn"
              onClick={this.createClicked}
            >
              <span className="fa fa-plus" />
            </Button>
          </Col>
        </Row>
        {this.renderSwitch()}
      </React.Fragment>
    );
  }
}

const mapState = (state, ownProps) => {
  return {};
};

const mapDispatch = {};

export default connect(
  mapState,
  mapDispatch
)(WebEditTocContainer);
